import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const features = [{
  title: 'Ahorro de +100 Horas al Año',
  desc: 'Descargás, personalizás y entregás en minutos.'
}, {
  title: 'Adherencia Real del Paciente',
  desc: 'Fases claras y seguimiento que hacen que cumpla solo.'
}, {
  title: 'Autoridad y Posicionamiento Premium',
  desc: 'Material de alta gama que eleva tu consultorio.'
}, {
  title: 'Consultorio Escalable',
  desc: 'Atendés más pacientes y cobrás mejor con un sistema estandarizado.'
}];
export function FeaturesSection() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-42">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-43">
        <div className="text-center mb-10" data-id="element-44">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-slate-900" data-id="element-45">
            ¿QUÉ VAS A LOGRAR CON ESTE SISTEMA?
          </h2>
        </div>

        <ul className="space-y-4" data-id="element-46">
          {features.map((feature, i) => <motion.li key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-3 bg-slate-50 p-4 rounded-2xl border border-slate-100" data-id="element-47">
              <CheckCircle2 className="w-5 h-5 text-emerald-600 flex-shrink-0 mt-0.5" data-id="element-48" />
              <p className="text-slate-600 leading-relaxed text-sm" data-id="element-49">
                <span className="font-bold text-slate-900 block mb-0.5 text-base" data-id="element-50">
                  {feature.title}
                </span>
                {feature.desc}
              </p>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}